module.exports = __webpack_public_path__ + "img/thumbnail-header-12.cbb6ed4.jpeg";